import Gain from './Gain';
export default Gain;